import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getPurchasingOrgs } from 'ducks/options'
import { getListCOC, getCOCSummary, createCodeOfConduct } from 'ducks/codeOfConduct'
import { ProcurementContainer, ProcurementBody } from '../styled'
import { SCListCont, CardButtonBody, BodyCardContent, TitleContent, ValueContent } from './styled'
import { codeOfConductDetailsPath, homePath } from 'routes'
import { columns, scStatusOption } from './AttributeData'
import { MainBodyContent, SearchList, TablePagination, CustomButton } from 'components'
import { getBusinessPartners } from 'ducks/options'

const CodeOfConduct = (props) => {
  const { listCOC, summaryCOC, purchasingOrgs, businessPartners, userData } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = useState(userPageSize)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [vendorCode, setVendorCode] = useState('')

  React.useEffect(() => {
    window.scrollTo(0, 0)
    props.getListCOC({ page: 1, size: pageSize })
    props.getCOCSummary()
    props.getPurchasingOrgs()

    if (!businessPartners.data.length && !businessPartners.loading) {
      props.getBusinessPartners()
    }
  }, [])

  const getSummaryData = (status, getTitle = false) => {
    var value = summaryCOC.find(item => item.statusCode === status)
    if (value) {
      if (getTitle) {
        return value.statusName
      } else {
        return value.count || 0
      }
    } else {
      return 'loading...'
    }
  }

  return (
    <MainBodyContent 
      headerTitle='Supplier Code of Conduct'
      accessoriesHeader={
        <CustomButton
          onClick={() => setShowCreateModal(true)}
          icon='plus'
          btnColor='gray'
          title='Create' />
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList
            placeholder='Doc No., Vendor Name'
            fetchAPI={props.getListCOC}
            formSearchName='formSearchSC'
            hideProject
            pageSize={pageSize}
            filterDate
            filterStatus
            filterStatusOptions={scStatusOption}
            filterPurchasingOrg
            filterPurchasingOrgOption={purchasingOrgs} />
          {summaryCOC.length > 0 ?
            <div style={{ display: 'flex', marginTop: '10px' }}>
              {
                [15, 16, 17].map((status) => {
                  return (
                    <CardButtonBody>
                      <BodyCardContent onClick={() => props.getListCOC({ page: 1, size: pageSize, status: status })}>
                        <TitleContent>{getSummaryData(status, true)}</TitleContent>
                        <ValueContent>
                          <div className='ValueText'>{getSummaryData(status)}</div>
                        </ValueContent>
                      </BodyCardContent>
                    </CardButtonBody>
                  )
                })
              }
            </div> : null}
          <SCListCont>
            <ReactTable
              data={Object.keys(listCOC).length > 0 ? listCOC.data : []}
              columns={columns.tCocList(props.cocCol)}
              defaultPageSize={userPageSize}
              noDataText='No Supplier Code of Conduct found'
              previousText={<Icon name='arrow alternate circle left' />}
              nextText={<Icon name='arrow alternate circle right' />}
              className='-striped -highlight'

              PaginationComponent={TablePagination}
              pages={Object.keys(listCOC).length > 0 ? listCOC.totalPage : 0}
              currentPage={Object.keys(listCOC).length > 0 ? listCOC.page : 0}
              onPageChange={(pageIndex) => {
                props.getListCOC({ page: pageIndex + 1, size: pageSize })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.getListCOC({ page: pageIndex + 1, size: pageSize })
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      window.open(codeOfConductDetailsPath(rowInfo.original.id), '_blank')
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </SCListCont>
        </ProcurementBody>
      </ProcurementContainer>
      <Dialog
        open={showCreateModal}
        className='dialog-full-height' 
        maxWidth='sm' 
        fullWidth 
        style={{ zIndex: 10 }}
      >
        <DialogTitle>Create Code of Conduct</DialogTitle>
        <DialogContent>
          <form>
            <div className='rowFields'>
              <Field
                name='vendorCode'
                label='Business Partner Number'
                require
                type={type.select}
                loading={businessPartners.loading}
                options={businessPartners.data || []}
                specialOnChange={(data) => setVendorCode(data)}
                component={FieldInput} />
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
            <CustomButton
              onClick={() => {
                setShowCreateModal(false)
                setVendorCode('')
              }}
              btnColor='red'
              title='Cancel' />
            <CustomButton
              onClick={() => {
                props.createCodeOfConduct(
                  vendorCode, 
                  () => {
                    setVendorCode('')
                    // setShowCreateModal(false)
                    // props.getListCOC({ page: 1, size: pageSize })
                    // props.getCOCSummary()
                  }
                )
              }}
              disable={vendorCode === ''} 
              btnColor='blue'
              title='Create' />
          </div>
        </DialogActions>
      </Dialog>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => ({
  initialValues: {
    status: '-',
    purchasingOrg: '-',
  },
  listCOC: state.codeOfConduct.listCOC.data,
  summaryCOC: state.codeOfConduct.summaryCOC.data,
  purchasingOrgs: state.options.purchasingOrgs.data,
  businessPartners: state.options.businessPartners,
  valueForm: getFormValues('formSearchSC')(state),
  userData: state.authen.user||{}
})

const mapDispatchToProps = {
  getListCOC,
  getCOCSummary,
  getPurchasingOrgs,
  getBusinessPartners,
  createCodeOfConduct
}

const scForm = reduxForm({
  form: 'formSearchSC',
  enableReinitialize: true,
})(CodeOfConduct)

export default connect(mapStateToProps, mapDispatchToProps)(scForm)
